module.exports = __webpack_public_path__ + "static/img/图片3.b46962ff.png";